const locales = ['ko-KR', 'en-US', 'zh-CN'] as const;

type LocaleType = (typeof locales)[number];

const defaultLocale = 'ko-KR' as const satisfies LocaleType;

export type { LocaleType };
export { defaultLocale, locales };
